// services/authService.ts
import { FormData, Member, RegisteredMember } from "../Interface/Login.interface";
import { axiosInstance } from "./Api";



const authService = {

  login: async (payload: FormData): Promise<any> => {
    
    const response = await axiosInstance.post('/EcomHome/OnlineGetLogin', payload);
    return response.data;
  },
  Register: async (payload:Member):Promise<any> =>{
    
    const response = await axiosInstance.post('/Member/EcomMemberSave',payload)
    return response.data
  },
  getCustomerData: async():Promise<any> =>{
    const response = await axiosInstance.get('POS/getMemberdtlsjsno')
    return response.data
  }
};

export default authService;
